import { WatchQueryFetchPolicy } from '@apollo/client';
import { useNotificationContext } from '@modules/common/components/Notification/NotificationContext';
import { useGetQuantifyChartEQLProps } from '@modules/quantify/hooks/useFetchQuantifyChartData/useGetQuantifyChartEQLProps';
import useExecuteLazyEQL from 'v2/core/repository/edge-server/eql/useExecuteLazyEQL';
import { useGetUser } from 'v2/core/services/user';

interface useExecuteQantifyChaEqlParams {
  fetchPolicy?: WatchQueryFetchPolicy;
  abortSignal?: AbortSignal;
}

export function useExecuteQuantifyChartEql({
  fetchPolicy,
  abortSignal,
}: useExecuteQantifyChaEqlParams) {
  const {
    tenant: { id: tenantID },
  } = useGetUser();

  const { showErrorNotification } = useNotificationContext();

  const eqlProps = useGetQuantifyChartEQLProps();

  return useExecuteLazyEQL({
    input: {
      tenantID,
      eqlProps,
    },
    abortSignal,
    // To skip network calls on component update
    // Bug: https://github.com/apollographql/apollo-client/issues/7484
    fetchPolicy: fetchPolicy ?? 'network-only',
    skipDefaultVariables: true,
    onError: () => {
      showErrorNotification({
        contentComponent: 'Failed to fetch data.',
        props: {},
      });
    },
  });
}
